module.exports = __webpack_public_path__ + "static/media/btn@2x.9f493abb.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/sku/btn@2x.png
// module id = 808
// module chunks = 0